import StarIcon from "icons/StarIcon";
interface IPoint {
  value: number;
}
const Point = ({ value }: IPoint) => {
  return (
    <div className="max-w-32 justify-center rounded-3xl bg-[#df0303] text-white flex gap-2 py-1 px-2">
      <StarIcon className="text-[#ECF017]" />
      <div className="font-light">{value.toLocaleString()} คะแนน</div>
    </div>
  );
};
export default Point;
